:host {
    display: block;

    //[part=percentage] {
    //    stroke-width: 0;
    //}

}
